// eslint-disable-next-line import/no-anonymous-default-export
export default (prop) => {
  return function eventHandler(e) {
    this.setState({
      [prop]: e.target.value,
    });
  };
};
